import React, { useEffect, useState } from "react";
import "./styleAddNotification.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { getUserListForNotification, postCustomNotificationList, postCustomNotifications, updateCustomNotifications } from "../../services/notificationServices";
import { setNotificationData, setUsersData } from '../../features/notifications/notificationSlice';
import INCSUBButton from "../common/Button/INCSUBButton";
import ReactPaginate from "react-paginate";
import { Search } from "lucide-react";
import INCSUBSearchbar from "../common/SearchBar/INCSUBSearchbar";



function INCSUBAddNotification({ notification, setIsOpenAddNotification }) {
    const [loader, setLoader] = useState();
    const notificationData = useSelector((state) => state.notification.notificationData);
    const dispatch = useDispatch();
    const [pageNo, setPageNo] = useState(0);
    const [shimmer, setShimmer] = useState(false);
    const usersData = useSelector((state) => state.notification.users)
    const [startDate, setStartDate] = useState(new Date("2025/04/01"));
    const [searchKey, setSearchKey] = useState('');
    const [endDate, setEndDate] = useState(new Date());
    // State to store new platform detail
    const [newNotification, setnewNotification] = useState({
        customNotificationTitle: "",
        customNotificationType: "",
        customNotificationMessage: "",
        customNotificationScheduleDateTime: "",
        customNotificationImage: "",
        customNotificationImageFile: "",
        link: "",

    })


    useState(() => {
        if (notification) {
            setnewNotification(notification)
        }

    }, [notification])
    const [isEmptyField, setIsEmptyField] = useState(false);
    const navigate = useNavigate();

    const [imageError, setImageError] = useState(null);
    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {

            const file = e.target.files[0];

            // Create a new Blob (optional, as file is already a Blob)
            const blob = new Blob([file], { type: file.type });
            // Store the blob in state (assuming you have a setBlob state setter)
            setnewNotification((prev) => ({
                ...prev,
                customNotificationImageFile: blob,
            }))
            // Convert the file to a Data URL for image preview
            const reader = new FileReader();

            reader.onload = function (event) {
                const img = new Image();
                img.onload = function () {
                    const aspectRatio = img.width / img.height;
                    const targetRatio = 1 / 1;

                    // Allow for a small tolerance due to potential rounding
                    const tolerance = 0.01;
                    if (Math.abs(aspectRatio - targetRatio) > tolerance) {
                        setImageError(true);

                    } else {
                        setImageError(false);
                    }


                    const blob = new Blob([file], { type: file.type });
                    setnewNotification((prev) => ({
                        ...prev,
                        customNotificationImage: reader.result?.toString() || '',
                    })
                    )
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        }
    }




    const findUpdatedFields = (original, updated) => {
        let updatedData = {};
        Object.keys(original).forEach(key => {
            if (original[key] !== updated[key]) {
                updatedData[key] = updated[key];
            }
        });
        if (updated["customNotificationImageFile"] !== '') {
            updatedData["customNotificationImageFile"] = updated["customNotificationImageFile"]
        }

        if (Object.keys(updatedData).length > 0) {
            updatedData.customNotificationId = original.customNotificationId;
        }

        return Object.keys(updatedData).length > 0 ? updatedData : false;
    };



    const formatDateTime = (dateTime) => {
        try {
            const date = new Date(dateTime);
            const options = { year: "numeric", month: "2-digit", day: "2-digit" };
            const formattedDateSplit = date.toLocaleDateString("en-GB", options).replace(/\//g, "-").split('-');
            const formattedDate = `${formattedDateSplit[2]}-${formattedDateSplit[1]}-${formattedDateSplit[0]}`
            const hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, "0");
            const period = hours >= 12 ? "PM" : "AM";
            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${"00"}`;
            return `${formattedDate} ${formattedTime}`;
        } catch (err) {
            toast.error("Data format is wrong")
        }

    };


    function parseCustomDate(dateString) {
        try {
            const [datePart, timePart, period] = dateString.split(" ");
            const [year, month, day] = datePart.split("-").map(Number);
            const [hourStr, minuteStr] = timePart.split(":");
            let hour = Number(hourStr);
            const minute = Number(minuteStr);

            // Convert to 24-hour format
            if (period === "PM" && hour !== 12) hour += 12;
            if (period === "AM" && hour === 12) hour = 0;

            return new Date(year, month - 1, day, hour, minute);
        } catch (err) {
            toast.error("Data format is wrong")
        }
    }
    const validateURL = (value) => {
        try {
            new URL(value);
            return true;
        } catch {
            return false;
        }
    };
    const addCustomNotification = async () => {
        setLoader(true)
        const isInvalid = [
            newNotification.customNotificationImageFile,
            newNotification.customNotificationMessage,
            newNotification.customNotificationScheduleDateTime,
            newNotification.customNotificationTitle,
            newNotification.customNotificationType,
            newNotification.link

        ].some(field => field === '' || field === null || field === undefined);

        if (isInvalid) {
            setIsEmptyField(true);
            setLoader(false)
            return;
        }
        if ((newNotification.link !== "" && newNotification.link !== null) && !validateURL(newNotification.link)) {
            toast.error("Please enter a valid URL");
        }
        console.log(newNotification)
        try {
            const addData = await postCustomNotifications(newNotification);
            if (addData.status === 201) {
                setIsOpenAddNotification(false);
                toast.success("Added Successfully");
                const updatedData = {
                    ...newNotification,
                    customNotificationId: addData.data.data.idValue,
                    customNotificationCreatedTime: formatDateTime(new Date())
                }
                if (notificationData.customNotificationDetailsDtoList.length === 0) {
                    dispatch(setNotificationData({
                        "customNotificationDetailsDtoList": [
                            updatedData
                        ],
                        "totalPages": 1,
                        "isLastPage": true
                    }));

                } else {
                    const updatedList = [updatedData, ...notificationData.customNotificationDetailsDtoList]
                    dispatch(setNotificationData({
                        ...notificationData,
                        customNotificationDetailsDtoList: updatedList
                    }))
                }
            } else if (addData.status === 401) {
                window.localStorage.setItem("userData", null);
                window.localStorage.setItem('token', null);
                navigate('/login')
            } else if (addData.status) {
                toast.error(addData.data.error)
            }
            else if (![200, 401].includes(addData.status)) {
                toast.error(addData.data.message);
            }

        } catch (err) {
            toast.error('Something Went Wrong')
        } finally {
            setLoader(false)
        }


    }
    const updateCustomNotification = async (e) => {
        setLoader(true)
        const isInvalid = [
            newNotification.customNotificationImage,
            newNotification.customNotificationMessage,
            newNotification.customNotificationScheduleDateTime,
            newNotification.customNotificationTitle,
            newNotification.customNotificationType
        ].some(field => field === '' || field === null || field === undefined);

        if (isInvalid) {
            setIsEmptyField(true);
            setLoader(false)
            return;
        }
        const updatedFields = findUpdatedFields(notification, newNotification);
        if (!updatedFields || Object.keys(updatedFields).length === 0) {
            toast.warning("No update in previous fields");
            setLoader(false);
            return;
        }

        try {
            const addData = await updateCustomNotifications(updatedFields);
            if (addData.status === 200) {
                const updatedData = notificationData.customNotificationDetailsDtoList.map((n) =>
                    n.customNotificationId === newNotification.customNotificationId
                        ? newNotification  // Replace with the new notification
                        : n                // Keep the existing notification
                );
                dispatch(setNotificationData({
                    ...notificationData,
                    customNotificationDetailsDtoList: updatedData
                }));
                toast.success("Updated Successfully")
                setIsOpenAddNotification(false);

            } else if (addData.status === 401) {
                window.localStorage.setItem("userData", null);
                window.localStorage.setItem('token', null);
                navigate('/login')
            } else if (![200, 401].includes(addData.status)) {
                toast.error(addData.data.message);
            }

        } catch (err) {
            toast.error('Something Went Wrong')
        } finally {
            setLoader(false)
        }


    }
    const getAllUserListForNotification = async ({
        keyState = searchKey, // Optional search key for filtering user data.
        page = 0, // Current page number for pagination.
        size = 10, // Number of items per page.
        startDateInput = convertDateFormat(startDate),
        endDateInput = convertDateFormat(endDate)
    } = {}) => {
        setShimmer(true); // Set shimmer (loading indicator) to true while data is being fetched.

        try {
            // Call the API to get all employees with the provided parameters.
            const userList = await getUserListForNotification({
                search: keyState,
                page,
                size,
                startDate: startDateInput,
                endDate: endDateInput
            });
            if (userList.status === 200) {
                // If API call is successful, update the Redux store with the fetched data.
                dispatch(setUsersData(userList.data.data));
                const initializedData = {
                    ...userList.data.data,
                    userNotifyDetailsList: userList.data.data.userNotifyDetailsList.map(user => ({
                        ...user,
                        selected: false
                    }))
                };
                setUsers(initializedData);

            } else if (userList.status === 401) {
                // If the user is unauthorized, clear local storage and redirect to login page.
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (userList.status === 301) {
                toast.error(userList.message);
            } else if (userList.status === 500) {
                toast.error("Internal Server Error");
            } else if (![200, 401, 301].includes(userList.status)) {
                // If API returns an unexpected status, display an error toast with the server's message.
                toast.error(userList.data.message);
            }
        } catch (error) {
            // Handle any unexpected errors during the API call.
            toast.error("Something went wrong");
        } finally {
            // Reset the shimmer (loading indicator) state regardless of success or failure.
            setShimmer(false);
        }
    };
    useEffect(() => {
        getAllUserListForNotification({
            keyState: "",
            page: pageNo,
            size: 10
        });
    }, []);


    const [users, setUsers] = useState(usersData);

    const toggleUser = (id) => {

        setUsers((prev) => ({
            ...users,
            userNotifyDetailsList: users.userNotifyDetailsList.map((user) =>
                user.userId === id
                    ? { ...user, selected: !user.selected }
                    : user
            ),
        }));

    };


    const getSelectedUserIds = (users) => {
        return users.userNotifyDetailsList
            .filter(user => user.selected)
            .map(user => user.userId);
    };

    const convertDateFormat = (date) => {
        if (date === '') return "";

        const dateObj = new Date(date);
        const formattedDate = dateObj
            .toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            })
            .replace("/", "/");

        const splitDate = formattedDate.split('/');

        if (splitDate[2].length === 4) {
            return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
        }

        return formattedDate;
    };

    const addCustomNotificationUserList = async () => {
        setLoader(true);

        // ✅ Get selected user IDs from list
        const selectedUserIds = getSelectedUserIds(users); // <-- your state

        const updatedNotification = {
            ...newNotification,
            userId: selectedUserIds
        };

        const isInvalid = [
            updatedNotification.customNotificationTitle,
            updatedNotification.customNotificationMessage,
            updatedNotification.customNotificationScheduleDateTime,
            updatedNotification.customNotificationImageFile,
        ].some(
            (field) => field === "" || field === null || field === undefined
        );

        if (isInvalid || selectedUserIds.length === 0) {
            setIsEmptyField(true);
            setLoader(false);
            return;
        }

        try {
            const addData = await postCustomNotificationList(updatedNotification);

            if (addData.status === 201) {
                setIsOpenAddNotification(false);
                toast.success("Added Successfully");

                const updatedData = {
                    ...updatedNotification,
                    customNotificationId: addData.data.data.idValue,
                    customNotificationCreatedTime: formatDateTime(new Date()),
                };

                const updatedList = [
                    updatedData,
                    ...(notificationData.customNotificationDetailsDtoList || [])
                ];

                dispatch(
                    setNotificationData({
                        ...notificationData,
                        customNotificationDetailsDtoList: updatedList,
                    })
                );
            }
            else if (addData.status === 401) {
                window.localStorage.setItem("userData", null);
                window.localStorage.setItem("token", null);
                navigate("/login");
            }
            else {
                toast.error(addData?.data?.message || "Something Went Wrong");
            }

        } catch (err) {
            toast.error("Something Went Wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleSearchUser = (search) => {
        setSearchKey((prevSearch) => {
            const newSearch = search;
            getAllUserListForNotification({ keyState: newSearch }); // Pass the updated state if needed
            return newSearch;
        });
    }


    const [currentPage, setCurrentPage] = useState(0);
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        const pageCount = users ? users.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            getAllUserListForNotification({ page: event.selected })
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBComplaints_list_section_container'>{
                !shimmer && users && users.userNotifyDetailsList && users?.userNotifyDetailsList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }



            </div>


        );
    }

    return (
        <div className="INCSUBAddNotification">
            <div className="INCSUBAddNotification_container">
                <div className="INCSUBAddNotification_feilds_container">
                    <svg onClick={() => setIsOpenAddNotification(false)} className="cancel_btn" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.46416 1.47683C1.77145 1.16963 2.18818 0.997049 2.6227 0.997049C3.05721 0.997049 3.47394 1.16963 3.78124 1.47683L9.99672 7.69231L16.2122 1.47683C16.3634 1.32032 16.5442 1.19548 16.7441 1.1096C16.944 1.02372 17.1591 0.978515 17.3766 0.976624C17.5942 0.974734 17.81 1.01619 18.0114 1.09859C18.2128 1.18098 18.3957 1.30266 18.5496 1.45652C18.7035 1.61038 18.8251 1.79334 18.9075 1.99473C18.9899 2.19611 19.0314 2.41189 19.0295 2.62947C19.0276 2.84706 18.9824 3.06208 18.8965 3.26201C18.8106 3.46193 18.6858 3.64275 18.5293 3.79391L12.3138 10.0094L18.5293 16.2249C18.8278 16.5339 18.9929 16.9479 18.9892 17.3775C18.9855 17.8072 18.8131 18.2182 18.5093 18.522C18.2055 18.8258 17.7945 18.9982 17.3648 19.0019C16.9352 19.0056 16.5213 18.8405 16.2122 18.542L9.99672 12.3265L3.78124 18.542C3.47218 18.8405 3.05825 19.0056 2.62859 19.0019C2.19894 18.9982 1.78794 18.8258 1.48412 18.522C1.18029 18.2182 1.00796 17.8072 1.00422 17.3775C1.00049 16.9479 1.16566 16.5339 1.46416 16.2249L7.67964 10.0094L1.46416 3.79391C1.15695 3.48661 0.984375 3.06989 0.984375 2.63537C0.984375 2.20085 1.15695 1.78413 1.46416 1.47683Z" fill="black" />
                    </svg>

                    <div className="INCSUBAddNotification_heading">Create Notification</div>
                    <hr className="INCSUBAddNotification_heading_hr" />
                    <div className="INCSUBINCSUBAddNotification_spillter">
                        <div className="INCSUBAddNotification_form_container">
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div className="INCSUBAdd_platform_form_fullfeild_container">
                                    {/* <label className="platform_name_label">Title <div>/20</div></label> */}
                                    <input placeholder="Notification Title" value={newNotification.customNotificationTitle} onChange={(e) => setnewNotification((prev) => ({ ...newNotification, customNotificationTitle: e.target.value }))} style={{ border: newNotification.customNotificationTitle === '' && isEmptyField ? "1px solid red" : null }} />
                                </div>
                                <div className="INCSUBAddNotification_form_halffeild_container split">
                                    <div className="INCSUBAddNotification_form_fullfeild_container">
                                        <div className="INCSUBAddNotification_form_fullfeild_container half">
                                            <label>Type</label>
                                            <select placeholder="Select a category" value={newNotification.customNotificationType} onChange={(e) => setnewNotification((prev) => ({ ...newNotification, customNotificationType: e.target.value }))} style={{ border: newNotification.customNotificationType === '' && isEmptyField ? "1px solid red" : null }}>
                                                <option value={''} style={{ color: '#A6A6A6' }} disabled selected>Select a Type</option>
                                                <option value={"Offer"}>Offer</option>
                                                <option value={"Celebration"}>Celebration</option>
                                                <option value={"Alert"}>Alert</option>
                                                <option value={"Other"}>Other</option>

                                            </select>
                                        </div>
                                        <div className="INCSUBAddNotification_form_fullfeild_container half">
                                            <label>Date & Time</label>
                                            <DatePicker
                                                placeholderText={"DD MM YYYY 00:00am"}
                                                selected={newNotification.customNotificationScheduleDateTime === "" ? null : parseCustomDate(newNotification.customNotificationScheduleDateTime)}
                                                onChange={(date) => {
                                                    const formatted = formatDateTime(date);
                                                    setnewNotification((prev) => ({
                                                        ...prev,
                                                        customNotificationScheduleDateTime: formatted
                                                    }));
                                                }}
                                                className={`${newNotification.customNotificationScheduleDateTime === '' && isEmptyField ? 'emptyField' : null}`}
                                                timeInputLabel="Time:"
                                                dateFormat="dd-MM-yyyy h:mm aa"
                                                showTimeInput
                                                minDate={new Date()}
                                                showIcon
                                                icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_367_5814)">
                                                        <path d="M12.6097 2.71875H3.37491C2.64631 2.71875 2.05566 3.3094 2.05566 4.038V13.2727C2.05566 14.0013 2.64631 14.592 3.37491 14.592H12.6097C13.3383 14.592 13.9289 14.0013 13.9289 13.2727V4.038C13.9289 3.3094 13.3383 2.71875 12.6097 2.71875Z" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M10.6299 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M5.35449 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M2.05566 6.67969H13.9289" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_367_5814">
                                                            <rect width="15.831" height="15.831" fill="white" transform="translate(0.0771484 0.0859375)" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>}
                                            />
                                        </div>
                                    </div>
                                    <div className="INCSUBAddNotification_image_container">
                                        <label>Image</label>
                                        <div className="INCSUBAddNotification_image" style={{ border: (!newNotification.customNotificationImage || newNotification.customNotificationImage === '') && isEmptyField ? "1px solid red" : null }}>
                                            <input type="file" accept="image/*" onChange={onSelectFile} style={{ border: newNotification.customNotificationImage === '' && isEmptyField ? "1px solid red" : null }} />
                                            <svg
                                                width="37"
                                                height="37"
                                                viewBox="0 0 37 37"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M18.5 7.71094V29.2943"
                                                    stroke="#606060"
                                                    strokeWidth="3.08333"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M7.7085 18.5H29.2918"
                                                    stroke="#606060"
                                                    strokeWidth="3.08333"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            {
                                                newNotification.customNotificationImage && <img className='INCSUBDisplay_img' src={newNotification.customNotificationImage} alt='/' />
                                            }
                                        </div>
                                        <div className="INCSUBAddNotification_image_ratio" style={{ color: imageError ? "red" : null }}>
                                            JPG / Size. 300x300 (1:1)  {imageError ? 'Image must have 1:1 aspect ratio' : null}

                                        </div>
                                    </div>

                                </div>
                                <div className="INCSUBAdd_platform_form_fullfeild_container">
                                    <label>
                                        Link
                                    </label>
                                    <input type="link" placeholder="link here..." value={newNotification.link} onChange={(e) => setnewNotification((prev) => ({ ...newNotification, link: e.target.value }))} style={{ border: newNotification.link === '' && isEmptyField ? "1px solid red" : null }} required></input>
                                </div>

                                <div className="INCSUBAdd_platform_form_fullfeild_container">
                                    <label>
                                        Messages <span>(1-2 lines)</span>
                                    </label>
                                    <textarea placeholder="type here..." value={newNotification.customNotificationMessage} onChange={(e) => setnewNotification((prev) => ({ ...newNotification, customNotificationMessage: e.target.value }))} style={{ border: newNotification.customNotificationMessage === '' && isEmptyField ? "1px solid red" : null }}></textarea>
                                </div>


                                {isEmptyField && <p className="error-message">All fields are required.</p>}

                                <div className="form-actions">
                                    <INCSUBButton text={notification ? "Update Notification" : "Send to all"} clickFun={notification ? updateCustomNotification : addCustomNotification} isBtnLoader={loader}>

                                    </INCSUBButton>
                                </div>
                            </form>
                        </div>
                        {!notification ?<div className="INCSUBAddNotification_container_list">
                            <div className='INCSUBuser_transaction_history_date_picker'>
                                <DatePicker selected={startDate} onChange={(date) => {
                                    setStartDate(date)
                                    getAllUserListForNotification({ startDateInput: convertDateFormat(date) })
                                }} selectsStart endDate={endDate} maxDate={endDate} placeholderText='Start Date' showIcon icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_367_5814)">
                                        <path d="M12.6097 2.71875H3.37491C2.64631 2.71875 2.05566 3.3094 2.05566 4.038V13.2727C2.05566 14.0013 2.64631 14.592 3.37491 14.592H12.6097C13.3383 14.592 13.9289 14.0013 13.9289 13.2727V4.038C13.9289 3.3094 13.3383 2.71875 12.6097 2.71875Z" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.6299 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.35449 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.05566 6.67969H13.9289" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_367_5814">
                                            <rect width="15.831" height="15.831" fill="white" transform="translate(0.0771484 0.0859375)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                } /> {"  -  "}
                                <DatePicker selected={endDate} onChange={(date) => {
                                    setEndDate(date)
                                    getAllUserListForNotification({ endDateInput: convertDateFormat(date) })
                                }} selectsEnd startDate={startDate} endDate={endDate} minDate={startDate} placeholderText='End Date' showIcon icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_367_5814)">
                                        <path d="M12.6097 2.71875H3.37491C2.64631 2.71875 2.05566 3.3094 2.05566 4.038V13.2727C2.05566 14.0013 2.64631 14.592 3.37491 14.592H12.6097C13.3383 14.592 13.9289 14.0013 13.9289 13.2727V4.038C13.9289 3.3094 13.3383 2.71875 12.6097 2.71875Z" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.6299 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.35449 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.05566 6.67969H13.9289" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_367_5814">
                                            <rect width="15.831" height="15.831" fill="white" transform="translate(0.0771484 0.0859375)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                } />
                            </div>
                            <h3>Target Audience</h3>
                            <div className="INCSUBAddNotification_header">

                                {users && users.length > 0 &&
                                    <span
                                        className="INCSUBAddNotification_select_all"

                                    >
                                        Select All
                                    </span>
                                }

                            </div>
                            <div className="INCSUBNotification_Searchbar_container">
                                <INCSUBSearchbar source={'notificationUsers'} placeholder={'Search Users'} param={{ pageNumber: pageNo, func: handleSearchUser }} />
                            </div>
                            <div className="INCSUBAddNotification_list">
                                {users && users.userNotifyDetailsList.length > 0 && users.userNotifyDetailsList.map((user) => (
                                    <div
                                        className="INCSUBAddNotification_list_item"
                                        key={user.userId}
                                    >
                                        <input
                                            type="checkbox"
                                            className="INCSUBAddNotification_checkbox"
                                            checked={!!user.selected}
                                            onChange={() => toggleUser(user.userId)}
                                        />

                                        <div className="INCSUBAddNotification_avatar">
                                            {user.userFullName ? user.userFullName.charAt(0).toUpperCase() : 'U'}
                                        </div>

                                        <div className="INCSUBAddNotification_info">
                                            <div className="INCSUBAddNotification_name">
                                                {user.userFullName || "Unknown User"}
                                            </div>
                                            {/* <div className="INCSUBAddNotification_role">
                                                {user.role}
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <PaginatedItems />
                            <div className="INCSUBAddNotification_footer">
                                <button className="INCSUBAddNotification_btn_cancel">
                                    Cancel
                                </button>
                                {/* <button className="INCSUBAddNotification_btn_primary" onClick={() => addCustomNotificationUserList()}>
                                    Send Notification →
                                </button> */}
                                <INCSUBButton text={"Send Notification →"} clickFun={addCustomNotificationUserList} isBtnLoader={loader}>

                                </INCSUBButton>
                            </div>
                        </div>:null}
                    </div>
                </div>
            </div >

        </div >
    );
}

export default INCSUBAddNotification;
